import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faBarsStaggered } from '@fortawesome/free-solid-svg-icons';
import { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from "react-router-dom";

export default function NavBar({ content }) {
    const [openmenu, setOpenmenu] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const componentRef = useRef(null);
    const navigate = useNavigate();

    // Function to scroll smoothly to a section
    const scrollToSection = (sectionKey) => {
        const cleanKey = sectionKey.startsWith("/") ? sectionKey.slice(1) : sectionKey; // Remove leading '/'

        setOpenmenu(false); // Close menu first

        setTimeout(() => {
            const section = document.getElementById(cleanKey);
            if (section) {
                section.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        }, 300); // Delay to let URL update first

        navigate(`#${cleanKey}`); // Update URL hash
    };

    // Handle Navbar Visibility on Scroll
    useEffect(() => {
        const checkVisibility = () => {
            if (componentRef.current) {
                const top = componentRef.current.getBoundingClientRect().top;
                const windowHeight = window.innerHeight;
                setIsVisible(top < windowHeight);
            }
        };

        window.addEventListener('scroll', checkVisibility);
        checkVisibility();

        return () => {
            window.removeEventListener('scroll', checkVisibility);
        };
    }, []);

    return (
        <div className={`sticky top-0 z-40 transition-opacity duration-500 ${isVisible ? 'opacity-100' : 'opacity-0'}`} ref={componentRef}>
            <nav className='flex justify-between items-center py-5 md:px-28 px-5 text-[#242938] bg-yellow-500'>
                {/* Logo */}
                <Link to={'/'}>
                    <div className='flex items-center gap-x-2 cursor-pointer'>
                        <div>
                            <img src={content.logo} className='w-14 h-14 rounded-lg' alt="Logo" />
                        </div>
                        <div className='font-bold text-2xl'>UniPro <span className='text-white'>World</span></div>
                    </div>
                </Link>

                {/* Desktop Navigation */}
                <div className='lg:flex hidden items-center gap-10 font-bold'>
                    {content.menuItems
                        .filter(item => item.is_active)
                        .sort((a, b) => a.seq - b.seq)
                        .map((item, index) => {
                            const isProduct = item.label === "Product";
                            return (
                                <div
                                    key={index}
                                    onClick={() => !isProduct && scrollToSection(item.link)}
                                    className={` flex items-baseline transition-opacity duration-300 ${isProduct
                                        ? "text-gray-500 cursor-not-allowed opacity-60 gap-1"
                                        : "hover:opacity-80 cursor-pointer"
                                        }`}
                                >
                                    <span>{item.label} {isProduct && (
                                        <sub className="text-[10px] text-gray-700 font-bold">
                                            <em>Coming Soon</em>
                                        </sub>
                                    )}</span>

                                </div>
                            );
                        })}
                </div>

                {/* Mobile Menu Button */}
                <div className='lg:hidden flex justify-center items-center cursor-pointer bg-white h-10 w-10 rounded-full shadow-md' onClick={() => setOpenmenu(!openmenu)}>
                    <FontAwesomeIcon icon={openmenu ? faXmark : faBarsStaggered} className="text-black" />
                </div>
            </nav>

            {/* Sidebar Menu for Mobile */}
            <div className={` lg:hidden visible fixed top-30 right-0 h-auto w-48 bg-white/80 shadow-lg rounded-xl transform transition-transform duration-500 ease-in-out z-50
                ${openmenu ? "translate-x-0" : "translate-x-full"}`}
            >
                <ul className="flex flex-col items-center gap-6 my-5 text-lg font-semibold">
                    {content.menuItems.map((item, index) => (
                        <li key={index} className="cursor-pointer hover:opacity-80 transition-opacity duration-300" onClick={() => scrollToSection(item.link)}>
                            {item.label}
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
